"use strict";

const FactSheetNew = require("../general/factSheetNew");
const StructuralBmpFactSheetController = require("../bmpfcs/structuralBmpFactSheetController");
const MuniBmpFactSheetController = require("../muni/muniBmpFactSheetController");

const LidBmpFactSheetController = function () {
  const routeName = "lid-bmp-fact-sheet";

  const lidBmpFactSheetRoute = {
    as: routeName,
    handler: function ({ data, hashString }) {
      open(data.id, { highlightId: hashString });
    },
  };

  const lidBmpFactSheetHighlightRoute = {
    as: `${routeName}-highlight`,
    handler: lidBmpFactSheetRoute.handler,
  };

  var getConfig = function () {
    return {
      ...StructuralBmpFactSheetController.getConfig(),
      closeUrl: "/ram/lid/lid-bmp",
      prepareDataFunction: MuniBmpFactSheetController.prepareData,
    };
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  return {
    open,
    routeName,
    lidBmpFactSheetRoute,
    lidBmpFactSheetHighlightRoute,
  };
};

module.exports = LidBmpFactSheetController();
